import React from 'react'
import ReactDOM from 'react-dom/client'
import ReactGA from 'react-ga'
import { BrowserRouter as Router } from 'react-router-dom'

import './index.scss'

import { currentJsonVersion } from './constants'
import { AUTH_KEY, AUTH_TOKEN, GA_ID } from './environment'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { UserContextProvider } from './UserContext'

// import ReactGA4 from 'react-ga'; // TODO: GA4 seems not to work
ReactGA.initialize(GA_ID)

const localAuthorKey = localStorage.getItem(AUTH_KEY)

const isReadOnly = !localAuthorKey || !AUTH_TOKEN || localAuthorKey !== AUTH_TOKEN
const initialUserConfig = {
  isReadOnly,
  isAdvanced: !isReadOnly,
  isAutoResize: false,
  isShowControls: !isReadOnly,
  isShowGallery: true,
  isFullscreen: false,
  isBroadcasting: false,
  isReceiving: false,
  version: currentJsonVersion,
  channelId: '',
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Router>
      <UserContextProvider initialUserConfig={initialUserConfig}>
        <App />
      </UserContextProvider>
    </Router>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
